import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { WidgetConfigurationFormType } from "modules/campaigns/components/Sections/triggers/widget"

export const useUpdateWidgetConfigurationQuery = () => {
  return useMutation({
    mutationFn: async (props: WidgetConfigurationFormType) => {
      const { data } = await axios.post(`/integrations/widget`, props)
      return data.data
    },
  })
}
